import { render, staticRenderFns } from "./CriteriaGroupsFilter.vue?vue&type=template&id=08c60514&scoped=true"
import script from "./CriteriaGroupsFilter.vue?vue&type=script&lang=js"
export * from "./CriteriaGroupsFilter.vue?vue&type=script&lang=js"
import style1 from "./CriteriaGroupsFilter.vue?vue&type=style&index=1&id=08c60514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c60514",
  null
  
)

export default component.exports